module.exports = __webpack_public_path__ + "static/media/jam.28557e59.png";